// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* messagesdetail.css */

.main-chat-page {
  padding-top: 50px;
  background-color: rgba(43, 167, 105, 0.12);
  min-height: 100vh;
}

/* ===== هدر ===== */
.personal-info {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

/* ===== کانتینر اصلی ===== */
.chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  position: relative;
  background-color: rgba(43, 167, 105, 0.12);
  background-image: radial-gradient(circle at 50% 50%, rgba(43, 167, 105, 0.12) 1px, transparent 0);
  background-size: 20px 20px;
}

.messages-list {
  display: flex;
  flex-direction: column;
  padding: 12px 14px 80px 14px;
  overflow-y: auto;
  gap: 8px;
  
 
}

/* ===== چیدمان پیام‌ها ===== */
.message-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.wrapper-student {
  align-items: flex-start; /* پیام‌های کاربر (شما) */
}

.wrapper-other {
  align-items: flex-end; /* پیام‌های استاد / پشتیبان */
}

/* ===== حباب پیام ===== */
.message-bubble {
  position: relative;
  padding: 6px 10px;
  max-width: 80%;
  min-width: 140px;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 3px;
  word-break: break-word;
}

.bubble-student {
  background: #faedd8;
  color: #111111;
  border-bottom-right-radius: 3px;
}

.bubble-other {
  background: #ffffff;
  color: #111111;
  border-bottom-left-radius: 3px;
}

/* ===== برچسب تمرین ===== */
.exercise-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(43, 167, 105, 0.12);
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 11px;
  color: #1b6d44;
  width: fit-content;
  max-width: 100%;
  margin-bottom: 2px;
}

.exercise-badge-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

/* ===== باکس ریپلای داخل حباب (Telegram Inline Quote) ===== */
.telegram-reply-quote {
  display: flex;
  align-items: stretch;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  margin-bottom: 4px;
  overflow: hidden;
  cursor: pointer;
  direction: rtl;
  -webkit-user-select: none;
          user-select: none;
}

.reply-quote-bar {
  width: 3.5px;
  background-color: #2BA769;
  flex-shrink: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.reply-quote-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3px 8px;
  min-width: 0;
  flex: 1 1;
}

.reply-quote-author {
  font-size: 11.5px;
  font-weight: 700;
  color: #2BA769;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reply-quote-text {
  font-size: 12px;
  color: #444444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
  margin-top: 1px;
}

/* ===== فایل پیوست (حل مشکل Overflow نام فایل) ===== */
.message-attachment {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin-top: 2px;
}

.file-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.05);
  color: #212529;
  text-decoration: none;
  font-size: 12.5px;
  max-width: 100%;
  transition: background 0.2s;
}

.file-link:hover {
  background: rgba(0, 0, 0, 0.09);
  color: #000;
}

.file-icon {
  flex-shrink: 0;
}

.file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: ltr;
  text-align: right;
  flex: 1 1;
}

/* ===== متن پیام ===== */
.message-text {
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  direction: rtl;
}

/* ===== فوتر پیام ===== */
.message-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 2px;
  align-self: flex-end;
}

.message-time {
  font-size: 10px;
  color: #707579;
  direction: ltr;
}

.reply-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #707579;
  opacity: 0.3;
  display: flex;
  align-items: center;
  transition: opacity 0.2s;
}

.message-bubble:hover .reply-btn,
.reply-btn.visible {
  opacity: 1;
}

/* ===== باکس ریپلای بالای Input ===== */
.reply-input-box {
  position: fixed;
  bottom: 56px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
 
  background: #ffffff;
  padding: 6px 12px;
  border-top: 1px solid #e0e0e0;
  border-right: 3px solid #2BA769;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 20;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.reply-input-content {
  flex: 1 1;
  min-width: 0;
}

.reply-input-label {
  font-size: 11px;
  font-weight: 700;
  color: #2BA769;
}

.reply-input-message {
  font-size: 12.5px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reply-input-close {
  background: none;
  border: none;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  padding: 2px 6px;
}

/* ===== فایل انتخاب شده ===== */
.selected-file-box {
  position: fixed;
  bottom: 56px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px;
  background: #ffffff;
  padding: 6px 12px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 19;
  font-size: 12px;
  color: #444;
}

.selected-file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
}

.selected-file-box button {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
}

/* ===== ورودی پیام (Input Container) ===== */
.input-container {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
 
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #ffffff;
  border-top: 1px solid #e0e0e0;
  z-index: 10;
}

.attach-button {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #707579;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
}

.attach-button:hover {
  background: #f0f0f0;
  color: #2BA769;
}

.message-input {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
  color: #222;
  direction: rtl;
}

.send-button {
  background: transparent;
  border: none;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
}

.send-button:hover:not(:disabled) {
  background: #f0f2f5;
}

.send-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ===== اسکرول بار ===== */
.messages-list::-webkit-scrollbar {
  width: 4px;
}

.messages-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

/* ===== ریسپانسیو ===== */
@media (max-width: 640px) {
  .message-bubble {
    max-width: 88%;
  }

  .input-container,
  .reply-input-box,
  .selected-file-box {
    max-width: 100%;
  }
}

/* در فایل messagesdetail.css اضافه کنید */

/* استایل برای ریپلای قابل کلیک */
.clickable-reply {
  cursor: pointer;
  transition: opacity 0.2s;
}

.clickable-reply:hover {
  opacity: 0.8;
}

.clickable-reply:hover .reply-quote-bar {
  background-color: #2BA769 !important;
}

/* هایلایت پیام هنگام اسکرول */
.message-highlighted .message-bubble {
  animation: highlight-flash 0.5s ease-in-out;
  border: 2px solid #2BA769 !important;
  box-shadow: 0 0 20px rgba(43, 167, 105, 0.3);
}

@keyframes highlight-flash {
  0% {
    transform: scale(1);
  
  }
  50% {
    transform: scale(1.02);
   
  }
  100% {
    transform: scale(1);
 
  }
}

/* استایل برای پیام‌های دانشجو هنگام هایلایت */
.message-highlighted.bubble-student {
  border: 2px solid #2BA769 !important;
}

/* استایل برای پیام‌های دیگر هنگام هایلایت */
.message-highlighted.bubble-other {
  border: 2px solid #FF6B35 !important;
}

/* در فایل messagesdetail.css اضافه کنید */

/* ============ استایل خطا با انیمیشن از بالا ============ */
.error-container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 500px;
  z-index: 9999;
  padding: 12px 16px;
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  pointer-events: none;
}

.error-container.error-visible {
  top: 20px;
  pointer-events: auto;
  animation: errorSlideDown 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
}

.error-container.error-hidden {
  top: -100px;
  animation: errorSlideUp 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
}

@keyframes errorSlideDown {
  0% {
    top: -100px;
    opacity: 0;
    transform: translateX(-50%) scale(0.8);
  }
  60% {
    top: 30px;
    opacity: 1;
    transform: translateX(-50%) scale(1.05);
  }
  100% {
    top: 20px;
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
}

@keyframes errorSlideUp {
  0% {
    top: 20px;
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
  100% {
    top: -100px;
    opacity: 0;
    transform: translateX(-50%) scale(0.8);
  }
}

.error-content {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border-radius: 12px;
  padding: 14px 18px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);
  border-right: 4px solid #DC2626;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
}

.error-icon-wrapper {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FEE2E2;
  border-radius: 50%;
  animation: errorPulse 1.5s ease-in-out infinite;
}

@keyframes errorPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.error-text {
  flex: 1 1;
  color: #991B1B;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  direction: rtl;
}

.error-close-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #991B1B;
  cursor: pointer;
  transition: all 0.2s;
}

.error-close-btn:hover {
  background: #FEE2E2;
  transform: rotate(90deg);
}

/* استایل برای اینپوت وقتی خطا دارد */
.message-input.input-error {
  border-color: #DC2626 !important;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
  animation: inputShake 0.5s ease-in-out;
}

@keyframes inputShake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-8px);
  }
  40% {
    transform: translateX(8px);
  }
  60% {
    transform: translateX(-4px);
  }
  80% {
    transform: translateX(4px);
  }
}

/* استایل برای ریپلای قابل کلیک */
.clickable-reply {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-reply:hover {
  opacity: 0.8;
  transform: translateX(-2px);
}

.clickable-reply:hover .reply-quote-bar {
  background-color: #2BA769 !important;
}

/* هایلایت پیام هنگام اسکرول */
.message-highlighted .message-bubble {
  animation: highlight-flash 0.8s ease-in-out;
  border: 2px solid #2BA769 !important;
  box-shadow: 0 0 20px rgba(43, 167, 105, 0.3);
}

@keyframes highlight-flash {
  0% {
    transform: scale(1);
    background-color: rgba(43, 167, 105, 0);
  }
  30% {
    transform: scale(1.03);
    background-color: rgba(43, 167, 105, 0.15);
  }
  60% {
    transform: scale(1.02);
    background-color: rgba(43, 167, 105, 0.1);
  }
  100% {
    transform: scale(1);
    background-color: rgba(43, 167, 105, 0);
  }
}

/* در فایل messagesdetail.css اضافه کنید */

/* ============ استایل خطا با انیمیشن از بالا ============ */
.error-container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 500px;
  z-index: 9999;
  padding: 12px 16px;
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  pointer-events: none;
}

.error-container.error-visible {
  top: 20px;
  pointer-events: auto;
  animation: errorSlideDown 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
}

.error-container.error-hidden {
  top: -100px;
  animation: errorSlideUp 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
}

@keyframes errorSlideDown {
  0% {
    top: -100px;
    opacity: 0;
    transform: translateX(-50%) scale(0.8);
  }
  60% {
    top: 30px;
    opacity: 1;
    transform: translateX(-50%) scale(1.05);
  }
  100% {
    top: 20px;
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
}

@keyframes errorSlideUp {
  0% {
    top: 20px;
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
  100% {
    top: -100px;
    opacity: 0;
    transform: translateX(-50%) scale(0.8);
  }
}

.error-content {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border-radius: 12px;
  padding: 14px 18px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);
  border-right: 4px solid #DC2626;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
}

.error-icon-wrapper {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FEE2E2;
  border-radius: 50%;
  animation: errorPulse 1.5s ease-in-out infinite;
}

@keyframes errorPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.error-text {
  flex: 1 1;
  color: #991B1B;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  direction: rtl;
}

.error-close-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #991B1B;
  cursor: pointer;
  transition: all 0.2s;
}

.error-close-btn:hover {
  background: #FEE2E2;
  transform: rotate(90deg);
}

/* استایل برای اینپوت وقتی خطا دارد */
.message-input.input-error {
  border-color: #DC2626 !important;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
  animation: inputShake 0.5s ease-in-out;
}

@keyframes inputShake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-8px);
  }
  40% {
    transform: translateX(8px);
  }
  60% {
    transform: translateX(-4px);
  }
  80% {
    transform: translateX(4px);
  }
}

/* استایل برای ریپلای قابل کلیک */
.clickable-reply {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-reply:hover {
  opacity: 0.8;
  transform: translateX(-2px);
}

.clickable-reply:hover .reply-quote-bar {
  background-color: #2BA769 !important;
}

/* هایلایت پیام هنگام اسکرول */
.message-highlighted .message-bubble {
  animation: highlight-flash 0.8s ease-in-out;
  border: 2px solid #2BA769 !important;
  box-shadow: 0 0 20px rgba(43, 167, 105, 0.3);
}

@keyframes highlight-flash {
  0% {
    transform: scale(1);
    background-color: rgba(43, 167, 105, 0);
  }
  30% {
    transform: scale(1.03);
    background-color: rgba(43, 167, 105, 0.15);
  }
  60% {
    transform: scale(1.02);
    background-color: rgba(43, 167, 105, 0.1);
  }
  100% {
    transform: scale(1);
    background-color: rgba(43, 167, 105, 0);
  }
}


/* اضافه کردن به انتهای فایل coursedetail.css */

/* ====== دکمه تیکت ریسپانسیو ====== */

/* دسکتاپ */
.ticket-button-wrapper {
    position: fixed;
    bottom: 120px;
    left: 20px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

/* تبلت (768px تا 1024px) */
@media (max-width: 1024px) and (min-width: 769px) {
    .ticket-button-wrapper {
        bottom: 100px !important;
        left: 15px !important;
    }
    
    .ticket-button-wrapper img {
        width: 65px !important;
        height: 65px !important;
    }
    
    .ticket-button-wrapper .ticket-button-text {
        font-size: 14px !important;
        padding: 6px 16px !important;
    }
}

/* موبایل (تا 768px) */
@media (max-width: 768px) {
    .ticket-button-wrapper {
        bottom: 90px !important;
        left: 10px !important;
    }
    
    .ticket-button-wrapper .ticket-button-text {
        font-size: 12px !important;
        padding: 5px 12px !important;
        margin-bottom: 8px !important;
        gap: 4px !important;
        animation: none !important;
        box-shadow: 0 3px 10px rgba(40, 167, 69, 0.3) !important;
    }
    
    .ticket-button-wrapper .ticket-button-text span:first-child {
        font-size: 16px !important;
    }
    
    .ticket-button-wrapper .ticket-button-text span:last-child {
        font-size: 8px !important;
        padding: 1px 6px !important;
    }
    
    .ticket-button-wrapper img {
        width: 55px !important;
        height: 55px !important;
        filter: drop-shadow(0 4px 12px rgba(40, 167, 69, 0.3)) !important;
    }
    
    /* حلقه نئون در موبایل کوچک‌تر */
    .ticket-button-wrapper > div > div:first-child {
        width: 70px !important;
        height: 70px !important;
        animation: none !important;
        background: rgba(40, 167, 69, 0.1) !important;
    }
    
    /* نشانگر آنلاین در موبایل */
    .ticket-button-wrapper > div > div:last-child {
        width: 14px !important;
        height: 14px !important;
        bottom: 2px !important;
        right: 2px !important;
        border-width: 2px !important;
        animation: none !important;
    }
}

/* موبایل کوچک (تا 480px) */
@media (max-width: 480px) {
    .ticket-button-wrapper {
        bottom: 30px !important;
        left: 10px !important;
    }
    
    .ticket-button-wrapper .ticket-button-text {
        font-size: 10px !important;
        padding: 4px 10px !important;
        margin-bottom: 6px !important;
        border-width: 1.5px !important;
    }
    
    .ticket-button-wrapper .ticket-button-text span:first-child {
        font-size: 14px !important;
    }
    
    .ticket-button-wrapper img {
        width: 45px !important;
        height: 45px !important;
    }
    
    .ticket-button-wrapper > div > div:first-child {
        width: 55px !important;
        height: 55px !important;
    }
    
    .ticket-button-wrapper > div > div:last-child {
        width: 12px !important;
        height: 12px !important;
        bottom: 1px !important;
        right: 1px !important;
        border-width: 1.5px !important;
    }
}

/* موبایل خیلی کوچک (تا 380px) */
@media (max-width: 380px) {
    .ticket-button-wrapper {
        bottom: 30px !important;
        left: 10px !important;
    }
    
    .ticket-button-wrapper .ticket-button-text {
        font-size: 9px !important;
        padding: 3px 8px !important;
        margin-bottom: 4px !important;
    }
    
    .ticket-button-wrapper .ticket-button-text span:first-child {
        font-size: 12px !important;
    }
    
    .ticket-button-wrapper img {
        width: 38px !important;
        height: 38px !important;
    }
    
    .ticket-button-wrapper > div > div:first-child {
        display: none !important;
    }
    
    .ticket-button-wrapper > div > div:last-child {
        width: 10px !important;
        height: 10px !important;
        bottom: 0px !important;
        right: 0px !important;
        border-width: 1.5px !important;
    }
}

/* اضافه کردن به انتهای فایل coursedetail.css */

/* انیمیشن بانس برای متن */
@keyframes bounce {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-5px);
    }
}

/* انیمیشن حلقه نئون */
@keyframes pulse-ring {
    0% {
        transform: scale(0.8);
        opacity: 0.8;
    }
    100% {
        transform: scale(1.4);
        opacity: 0;
    }
}

/* انیمیشن چشمک زدن نشانگر آنلاین */
@keyframes blink {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
}

/* استایل دکمه تیکت - اورراید */
.ticket-fab-btn {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
}

/* ریسپانسیو */
@media (max-width: 768px) {
    .ticket-fab-btn {
        bottom: 100px !important;
        left: 10px !important;
        padding: 12px 16px !important;
        font-size: 12px !important;
    }
    
    .ticket-fab-btn svg {
        width: 20px !important;
        height: 20px !important;
    }
}

/* اضافه کردن به coursedetail.css */

@keyframes bounce {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-5px);
    }
}

@keyframes pulse-ring {
    0% {
        transform: scale(0.8);
        opacity: 0.8;
    }
    100% {
        transform: scale(1.3);
        opacity: 0;
    }
}

@keyframes blink {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/messagesdetail.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,0CAA0C;EAC1C,iGAAiG;EACjG,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,QAAQ;;;AAGV;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB,EAAE,yBAAyB;AACpD;;AAEA;EACE,qBAAqB,EAAE,6BAA6B;AACtD;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,SAAO;AACT;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;;EAEX,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,cAAc;EAChB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA,0CAA0C;;AAE1C,iCAAiC;AACjC;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;;EAErB;EACA;IACE,sBAAsB;;EAExB;EACA;IACE,mBAAmB;;EAErB;AACF;;AAEA,8CAA8C;AAC9C;EACE,oCAAoC;AACtC;;AAEA,4CAA4C;AAC5C;EACE,oCAAoC;AACtC;;AAEA,0CAA0C;;AAE1C,4DAA4D;AAC5D;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,SAAS;IACT,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,SAAS;IACT,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,WAAW;IACX,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2EAA2E;EAC3E,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;EACA;IACE,mBAAmB;IACnB,uCAAuC;EACzC;AACF;;AAEA,0CAA0C;;AAE1C,4DAA4D;AAC5D;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,SAAS;IACT,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,SAAS;IACT,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,WAAW;IACX,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2EAA2E;EAC3E,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;EACA;IACE,mBAAmB;IACnB,uCAAuC;EACzC;AACF;;;AAGA,+CAA+C;;AAE/C,sCAAsC;;AAEtC,WAAW;AACX;IACI,eAAe;IACf,aAAa;IACb,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI;QACI,wBAAwB;QACxB,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,6BAA6B;QAC7B,mBAAmB;QACnB,0BAA0B;QAC1B,wDAAwD;IAC5D;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,iEAAiE;IACrE;;IAEA,gCAAgC;IAChC;QACI,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;QAC1B,6CAA6C;IACjD;;IAEA,4BAA4B;IAC5B;QACI,sBAAsB;QACtB,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,4BAA4B;QAC5B,0BAA0B;IAC9B;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,8BAA8B;IAClC;AACJ;;AAEA,gCAAgC;AAChC;IACI;QACI,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,8BAA8B;IAClC;AACJ;;AAEA,+CAA+C;;AAE/C,0BAA0B;AAC1B;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA,mCAAmC;AACnC;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;AACJ;;AAEA,+BAA+B;AAC/B;IACI,4BAA4B;AAChC;;AAEA;IACI,KAAK,mBAAmB,EAAE;IAC1B,MAAM,sBAAsB,EAAE;IAC9B,OAAO,mBAAmB,EAAE;AAChC;;AAEA,cAAc;AACd;IACI;QACI,wBAAwB;QACxB,qBAAqB;QACrB,6BAA6B;QAC7B,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA,mCAAmC;;AAEnC;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* messagesdetail.css */\n\n.main-chat-page {\n  padding-top: 50px;\n  background-color: rgba(43, 167, 105, 0.12);\n  min-height: 100vh;\n}\n\n/* ===== هدر ===== */\n.personal-info {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* ===== کانتینر اصلی ===== */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 50px);\n  position: relative;\n  background-color: rgba(43, 167, 105, 0.12);\n  background-image: radial-gradient(circle at 50% 50%, rgba(43, 167, 105, 0.12) 1px, transparent 0);\n  background-size: 20px 20px;\n}\n\n.messages-list {\n  display: flex;\n  flex-direction: column;\n  padding: 12px 14px 80px 14px;\n  overflow-y: auto;\n  gap: 8px;\n  \n \n}\n\n/* ===== چیدمان پیام‌ها ===== */\n.message-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.wrapper-student {\n  align-items: flex-start; /* پیام‌های کاربر (شما) */\n}\n\n.wrapper-other {\n  align-items: flex-end; /* پیام‌های استاد / پشتیبان */\n}\n\n/* ===== حباب پیام ===== */\n.message-bubble {\n  position: relative;\n  padding: 6px 10px;\n  max-width: 80%;\n  min-width: 140px;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  word-break: break-word;\n}\n\n.bubble-student {\n  background: #faedd8;\n  color: #111111;\n  border-bottom-right-radius: 3px;\n}\n\n.bubble-other {\n  background: #ffffff;\n  color: #111111;\n  border-bottom-left-radius: 3px;\n}\n\n/* ===== برچسب تمرین ===== */\n.exercise-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(43, 167, 105, 0.12);\n  border-radius: 6px;\n  padding: 2px 8px;\n  font-size: 11px;\n  color: #1b6d44;\n  width: fit-content;\n  max-width: 100%;\n  margin-bottom: 2px;\n}\n\n.exercise-badge-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 180px;\n}\n\n/* ===== باکس ریپلای داخل حباب (Telegram Inline Quote) ===== */\n.telegram-reply-quote {\n  display: flex;\n  align-items: stretch;\n  background: rgba(0, 0, 0, 0.08);\n  border-radius: 6px;\n  margin-bottom: 4px;\n  overflow: hidden;\n  cursor: pointer;\n  direction: rtl;\n  user-select: none;\n}\n\n.reply-quote-bar {\n  width: 3.5px;\n  background-color: #2BA769;\n  flex-shrink: 0;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.reply-quote-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 3px 8px;\n  min-width: 0;\n  flex: 1;\n}\n\n.reply-quote-author {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #2BA769;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.reply-quote-text {\n  font-size: 12px;\n  color: #444444;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n  margin-top: 1px;\n}\n\n/* ===== فایل پیوست (حل مشکل Overflow نام فایل) ===== */\n.message-attachment {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  margin-top: 2px;\n}\n\n.file-link {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.05);\n  color: #212529;\n  text-decoration: none;\n  font-size: 12.5px;\n  max-width: 100%;\n  transition: background 0.2s;\n}\n\n.file-link:hover {\n  background: rgba(0, 0, 0, 0.09);\n  color: #000;\n}\n\n.file-icon {\n  flex-shrink: 0;\n}\n\n.file-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  direction: ltr;\n  text-align: right;\n  flex: 1;\n}\n\n/* ===== متن پیام ===== */\n.message-text {\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  direction: rtl;\n}\n\n/* ===== فوتر پیام ===== */\n.message-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  margin-top: 2px;\n  align-self: flex-end;\n}\n\n.message-time {\n  font-size: 10px;\n  color: #707579;\n  direction: ltr;\n}\n\n.reply-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #707579;\n  opacity: 0.3;\n  display: flex;\n  align-items: center;\n  transition: opacity 0.2s;\n}\n\n.message-bubble:hover .reply-btn,\n.reply-btn.visible {\n  opacity: 1;\n}\n\n/* ===== باکس ریپلای بالای Input ===== */\n.reply-input-box {\n  position: fixed;\n  bottom: 56px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n \n  background: #ffffff;\n  padding: 6px 12px;\n  border-top: 1px solid #e0e0e0;\n  border-right: 3px solid #2BA769;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 20;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.reply-input-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.reply-input-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #2BA769;\n}\n\n.reply-input-message {\n  font-size: 12.5px;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.reply-input-close {\n  background: none;\n  border: none;\n  color: #888;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 2px 6px;\n}\n\n/* ===== فایل انتخاب شده ===== */\n.selected-file-box {\n  position: fixed;\n  bottom: 56px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  max-width: 600px;\n  background: #ffffff;\n  padding: 6px 12px;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 19;\n  font-size: 12px;\n  color: #444;\n}\n\n.selected-file-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 80%;\n}\n\n.selected-file-box button {\n  background: none;\n  border: none;\n  color: #999;\n  cursor: pointer;\n}\n\n/* ===== ورودی پیام (Input Container) ===== */\n.input-container {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n \n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #ffffff;\n  border-top: 1px solid #e0e0e0;\n  z-index: 10;\n}\n\n.attach-button {\n  background: none;\n  border: none;\n  padding: 6px;\n  cursor: pointer;\n  color: #707579;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border-radius: 50%;\n}\n\n.attach-button:hover {\n  background: #f0f0f0;\n  color: #2BA769;\n}\n\n.message-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  background: transparent;\n  color: #222;\n  direction: rtl;\n}\n\n.send-button {\n  background: transparent;\n  border: none;\n  padding: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border-radius: 50%;\n}\n\n.send-button:hover:not(:disabled) {\n  background: #f0f2f5;\n}\n\n.send-button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ===== اسکرول بار ===== */\n.messages-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.messages-list::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 2px;\n}\n\n/* ===== ریسپانسیو ===== */\n@media (max-width: 640px) {\n  .message-bubble {\n    max-width: 88%;\n  }\n\n  .input-container,\n  .reply-input-box,\n  .selected-file-box {\n    max-width: 100%;\n  }\n}\n\n/* در فایل messagesdetail.css اضافه کنید */\n\n/* استایل برای ریپلای قابل کلیک */\n.clickable-reply {\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.clickable-reply:hover {\n  opacity: 0.8;\n}\n\n.clickable-reply:hover .reply-quote-bar {\n  background-color: #2BA769 !important;\n}\n\n/* هایلایت پیام هنگام اسکرول */\n.message-highlighted .message-bubble {\n  animation: highlight-flash 0.5s ease-in-out;\n  border: 2px solid #2BA769 !important;\n  box-shadow: 0 0 20px rgba(43, 167, 105, 0.3);\n}\n\n@keyframes highlight-flash {\n  0% {\n    transform: scale(1);\n  \n  }\n  50% {\n    transform: scale(1.02);\n   \n  }\n  100% {\n    transform: scale(1);\n \n  }\n}\n\n/* استایل برای پیام‌های دانشجو هنگام هایلایت */\n.message-highlighted.bubble-student {\n  border: 2px solid #2BA769 !important;\n}\n\n/* استایل برای پیام‌های دیگر هنگام هایلایت */\n.message-highlighted.bubble-other {\n  border: 2px solid #FF6B35 !important;\n}\n\n/* در فایل messagesdetail.css اضافه کنید */\n\n/* ============ استایل خطا با انیمیشن از بالا ============ */\n.error-container {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90%;\n  max-width: 500px;\n  z-index: 9999;\n  padding: 12px 16px;\n  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  pointer-events: none;\n}\n\n.error-container.error-visible {\n  top: 20px;\n  pointer-events: auto;\n  animation: errorSlideDown 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;\n}\n\n.error-container.error-hidden {\n  top: -100px;\n  animation: errorSlideUp 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;\n}\n\n@keyframes errorSlideDown {\n  0% {\n    top: -100px;\n    opacity: 0;\n    transform: translateX(-50%) scale(0.8);\n  }\n  60% {\n    top: 30px;\n    opacity: 1;\n    transform: translateX(-50%) scale(1.05);\n  }\n  100% {\n    top: 20px;\n    opacity: 1;\n    transform: translateX(-50%) scale(1);\n  }\n}\n\n@keyframes errorSlideUp {\n  0% {\n    top: 20px;\n    opacity: 1;\n    transform: translateX(-50%) scale(1);\n  }\n  100% {\n    top: -100px;\n    opacity: 0;\n    transform: translateX(-50%) scale(0.8);\n  }\n}\n\n.error-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: white;\n  border-radius: 12px;\n  padding: 14px 18px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);\n  border-right: 4px solid #DC2626;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.error-icon-wrapper {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #FEE2E2;\n  border-radius: 50%;\n  animation: errorPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes errorPulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.error-text {\n  flex: 1;\n  color: #991B1B;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  direction: rtl;\n}\n\n.error-close-btn {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: #991B1B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.error-close-btn:hover {\n  background: #FEE2E2;\n  transform: rotate(90deg);\n}\n\n/* استایل برای اینپوت وقتی خطا دارد */\n.message-input.input-error {\n  border-color: #DC2626 !important;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n  animation: inputShake 0.5s ease-in-out;\n}\n\n@keyframes inputShake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  20% {\n    transform: translateX(-8px);\n  }\n  40% {\n    transform: translateX(8px);\n  }\n  60% {\n    transform: translateX(-4px);\n  }\n  80% {\n    transform: translateX(4px);\n  }\n}\n\n/* استایل برای ریپلای قابل کلیک */\n.clickable-reply {\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.clickable-reply:hover {\n  opacity: 0.8;\n  transform: translateX(-2px);\n}\n\n.clickable-reply:hover .reply-quote-bar {\n  background-color: #2BA769 !important;\n}\n\n/* هایلایت پیام هنگام اسکرول */\n.message-highlighted .message-bubble {\n  animation: highlight-flash 0.8s ease-in-out;\n  border: 2px solid #2BA769 !important;\n  box-shadow: 0 0 20px rgba(43, 167, 105, 0.3);\n}\n\n@keyframes highlight-flash {\n  0% {\n    transform: scale(1);\n    background-color: rgba(43, 167, 105, 0);\n  }\n  30% {\n    transform: scale(1.03);\n    background-color: rgba(43, 167, 105, 0.15);\n  }\n  60% {\n    transform: scale(1.02);\n    background-color: rgba(43, 167, 105, 0.1);\n  }\n  100% {\n    transform: scale(1);\n    background-color: rgba(43, 167, 105, 0);\n  }\n}\n\n/* در فایل messagesdetail.css اضافه کنید */\n\n/* ============ استایل خطا با انیمیشن از بالا ============ */\n.error-container {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90%;\n  max-width: 500px;\n  z-index: 9999;\n  padding: 12px 16px;\n  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  pointer-events: none;\n}\n\n.error-container.error-visible {\n  top: 20px;\n  pointer-events: auto;\n  animation: errorSlideDown 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;\n}\n\n.error-container.error-hidden {\n  top: -100px;\n  animation: errorSlideUp 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;\n}\n\n@keyframes errorSlideDown {\n  0% {\n    top: -100px;\n    opacity: 0;\n    transform: translateX(-50%) scale(0.8);\n  }\n  60% {\n    top: 30px;\n    opacity: 1;\n    transform: translateX(-50%) scale(1.05);\n  }\n  100% {\n    top: 20px;\n    opacity: 1;\n    transform: translateX(-50%) scale(1);\n  }\n}\n\n@keyframes errorSlideUp {\n  0% {\n    top: 20px;\n    opacity: 1;\n    transform: translateX(-50%) scale(1);\n  }\n  100% {\n    top: -100px;\n    opacity: 0;\n    transform: translateX(-50%) scale(0.8);\n  }\n}\n\n.error-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: white;\n  border-radius: 12px;\n  padding: 14px 18px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);\n  border-right: 4px solid #DC2626;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.error-icon-wrapper {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #FEE2E2;\n  border-radius: 50%;\n  animation: errorPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes errorPulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.error-text {\n  flex: 1;\n  color: #991B1B;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  direction: rtl;\n}\n\n.error-close-btn {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: #991B1B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.error-close-btn:hover {\n  background: #FEE2E2;\n  transform: rotate(90deg);\n}\n\n/* استایل برای اینپوت وقتی خطا دارد */\n.message-input.input-error {\n  border-color: #DC2626 !important;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n  animation: inputShake 0.5s ease-in-out;\n}\n\n@keyframes inputShake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  20% {\n    transform: translateX(-8px);\n  }\n  40% {\n    transform: translateX(8px);\n  }\n  60% {\n    transform: translateX(-4px);\n  }\n  80% {\n    transform: translateX(4px);\n  }\n}\n\n/* استایل برای ریپلای قابل کلیک */\n.clickable-reply {\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.clickable-reply:hover {\n  opacity: 0.8;\n  transform: translateX(-2px);\n}\n\n.clickable-reply:hover .reply-quote-bar {\n  background-color: #2BA769 !important;\n}\n\n/* هایلایت پیام هنگام اسکرول */\n.message-highlighted .message-bubble {\n  animation: highlight-flash 0.8s ease-in-out;\n  border: 2px solid #2BA769 !important;\n  box-shadow: 0 0 20px rgba(43, 167, 105, 0.3);\n}\n\n@keyframes highlight-flash {\n  0% {\n    transform: scale(1);\n    background-color: rgba(43, 167, 105, 0);\n  }\n  30% {\n    transform: scale(1.03);\n    background-color: rgba(43, 167, 105, 0.15);\n  }\n  60% {\n    transform: scale(1.02);\n    background-color: rgba(43, 167, 105, 0.1);\n  }\n  100% {\n    transform: scale(1);\n    background-color: rgba(43, 167, 105, 0);\n  }\n}\n\n\n/* اضافه کردن به انتهای فایل coursedetail.css */\n\n/* ====== دکمه تیکت ریسپانسیو ====== */\n\n/* دسکتاپ */\n.ticket-button-wrapper {\n    position: fixed;\n    bottom: 120px;\n    left: 20px;\n    z-index: 999;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n/* تبلت (768px تا 1024px) */\n@media (max-width: 1024px) and (min-width: 769px) {\n    .ticket-button-wrapper {\n        bottom: 100px !important;\n        left: 15px !important;\n    }\n    \n    .ticket-button-wrapper img {\n        width: 65px !important;\n        height: 65px !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text {\n        font-size: 14px !important;\n        padding: 6px 16px !important;\n    }\n}\n\n/* موبایل (تا 768px) */\n@media (max-width: 768px) {\n    .ticket-button-wrapper {\n        bottom: 90px !important;\n        left: 10px !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text {\n        font-size: 12px !important;\n        padding: 5px 12px !important;\n        margin-bottom: 8px !important;\n        gap: 4px !important;\n        animation: none !important;\n        box-shadow: 0 3px 10px rgba(40, 167, 69, 0.3) !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text span:first-child {\n        font-size: 16px !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text span:last-child {\n        font-size: 8px !important;\n        padding: 1px 6px !important;\n    }\n    \n    .ticket-button-wrapper img {\n        width: 55px !important;\n        height: 55px !important;\n        filter: drop-shadow(0 4px 12px rgba(40, 167, 69, 0.3)) !important;\n    }\n    \n    /* حلقه نئون در موبایل کوچک‌تر */\n    .ticket-button-wrapper > div > div:first-child {\n        width: 70px !important;\n        height: 70px !important;\n        animation: none !important;\n        background: rgba(40, 167, 69, 0.1) !important;\n    }\n    \n    /* نشانگر آنلاین در موبایل */\n    .ticket-button-wrapper > div > div:last-child {\n        width: 14px !important;\n        height: 14px !important;\n        bottom: 2px !important;\n        right: 2px !important;\n        border-width: 2px !important;\n        animation: none !important;\n    }\n}\n\n/* موبایل کوچک (تا 480px) */\n@media (max-width: 480px) {\n    .ticket-button-wrapper {\n        bottom: 30px !important;\n        left: 10px !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text {\n        font-size: 10px !important;\n        padding: 4px 10px !important;\n        margin-bottom: 6px !important;\n        border-width: 1.5px !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text span:first-child {\n        font-size: 14px !important;\n    }\n    \n    .ticket-button-wrapper img {\n        width: 45px !important;\n        height: 45px !important;\n    }\n    \n    .ticket-button-wrapper > div > div:first-child {\n        width: 55px !important;\n        height: 55px !important;\n    }\n    \n    .ticket-button-wrapper > div > div:last-child {\n        width: 12px !important;\n        height: 12px !important;\n        bottom: 1px !important;\n        right: 1px !important;\n        border-width: 1.5px !important;\n    }\n}\n\n/* موبایل خیلی کوچک (تا 380px) */\n@media (max-width: 380px) {\n    .ticket-button-wrapper {\n        bottom: 30px !important;\n        left: 10px !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text {\n        font-size: 9px !important;\n        padding: 3px 8px !important;\n        margin-bottom: 4px !important;\n    }\n    \n    .ticket-button-wrapper .ticket-button-text span:first-child {\n        font-size: 12px !important;\n    }\n    \n    .ticket-button-wrapper img {\n        width: 38px !important;\n        height: 38px !important;\n    }\n    \n    .ticket-button-wrapper > div > div:first-child {\n        display: none !important;\n    }\n    \n    .ticket-button-wrapper > div > div:last-child {\n        width: 10px !important;\n        height: 10px !important;\n        bottom: 0px !important;\n        right: 0px !important;\n        border-width: 1.5px !important;\n    }\n}\n\n/* اضافه کردن به انتهای فایل coursedetail.css */\n\n/* انیمیشن بانس برای متن */\n@keyframes bounce {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(-5px);\n    }\n}\n\n/* انیمیشن حلقه نئون */\n@keyframes pulse-ring {\n    0% {\n        transform: scale(0.8);\n        opacity: 0.8;\n    }\n    100% {\n        transform: scale(1.4);\n        opacity: 0;\n    }\n}\n\n/* انیمیشن چشمک زدن نشانگر آنلاین */\n@keyframes blink {\n    0%, 100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.3;\n    }\n}\n\n/* استایل دکمه تیکت - اورراید */\n.ticket-fab-btn {\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    0% { transform: scale(1); }\n    50% { transform: scale(1.05); }\n    100% { transform: scale(1); }\n}\n\n/* ریسپانسیو */\n@media (max-width: 768px) {\n    .ticket-fab-btn {\n        bottom: 100px !important;\n        left: 10px !important;\n        padding: 12px 16px !important;\n        font-size: 12px !important;\n    }\n    \n    .ticket-fab-btn svg {\n        width: 20px !important;\n        height: 20px !important;\n    }\n}\n\n/* اضافه کردن به coursedetail.css */\n\n@keyframes bounce {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(-5px);\n    }\n}\n\n@keyframes pulse-ring {\n    0% {\n        transform: scale(0.8);\n        opacity: 0.8;\n    }\n    100% {\n        transform: scale(1.3);\n        opacity: 0;\n    }\n}\n\n@keyframes blink {\n    0%, 100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.3;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
